import { render } from "./CZProjectedConsumptionCo2Gas.vue?vue&type=template&id=004ee42b&scoped=true&ts=true"
import script from "./CZProjectedConsumptionCo2Gas.vue?vue&type=script&lang=ts"
export * from "./CZProjectedConsumptionCo2Gas.vue?vue&type=script&lang=ts"

import "./CZProjectedConsumptionCo2Gas.vue?vue&type=style&index=0&id=004ee42b&scoped=true&lang=css"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004ee42b"]])

export default __exports__